import React, { FunctionComponent } from "react"
import "./LDSEllipsis.css"

interface Props {
    color?: string
}

const LDSEllipsis: FunctionComponent<Props> = (props) => {
    const bgColor = props.color ? props.color : "#7f7f7f"
    return (<div className="LDSEllipsis">
        <div style={{ backgroundColor: bgColor }}></div>
        <div style={{ backgroundColor: bgColor }}></div>
        <div style={{ backgroundColor: bgColor }}></div>
        <div style={{ backgroundColor: bgColor }}></div>
    </div>
    )
}

export default LDSEllipsis